import * as getters from './getters';
import * as actions from './actions';

export default {
  strict: true,
  state: {
    isFetchingStations: false,
    isFetchingTags: false,
    filteredGameIds: null,
  },
  getters,
  actions,
  mutations: {
    'stations/set': (state, { path, value }) => {
      state[path] = value;
    },
    'tags/set' (state, { path, value }) {
      state[path] = value;
    },
  },
};
